import { AfterViewInit, Component, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls : ['./support.component.css']
})
export class SupportComponent implements AfterViewInit, OnInit {

  constructor(public shared: SharedService) {

  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this.shared.includeMainScript();
  }

}
